import {
  de_default
} from "./chunk-RNANDVZ2.mjs";
import {
  en_default
} from "./chunk-4NZ5WTJG.mjs";
import {
  fr_default
} from "./chunk-R4TRZWI5.mjs";

// src/frontend/index.ts
var frontend_default = { en: en_default, fr: fr_default, de: de_default };

export {
  frontend_default
};
